var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.09,
    height: 20,
    viewBox: "0 0 115.09 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-white",
    transform: "translate(-63.4 -62.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(63.4 62.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_211",
    "data-name": "Trac\\xE9 211",
    d: "M77.449,65.616v.352a16.011,16.011,0,0,0-8.21,0,14.074,14.074,0,0,0-2.085.731c-.1.052-.222.091-.326.144-.065.026-.143.065-.209.091h0a15.652,15.652,0,0,0-2.932,1.8,18.963,18.963,0,0,1-.261-2.7l-.026-.953.834-.457A21.04,21.04,0,0,1,66.7,63.488c.13-.052.261-.091.4-.144a16.363,16.363,0,0,1,2.463-.666,19.054,19.054,0,0,1,7.559,0A12.763,12.763,0,0,1,77.449,65.616Z",
    transform: "translate(-63.4 -62.3)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_212",
    "data-name": "Trac\\xE9 212",
    d: "M163.906,72.719l-.026.953a18.781,18.781,0,0,1-.261,2.7c-.026.144-.052.274-.078.418a17.792,17.792,0,0,1-.652,2.48,19.928,19.928,0,0,1-1.134,2.663q-.2.392-.43.783A18.666,18.666,0,0,1,159.11,85.8a12.844,12.844,0,0,1-3.01-1.371,15.489,15.489,0,0,0,3.18-4.556,15.316,15.316,0,0,0,.925-2.559,15.952,15.952,0,0,0,.482-2.768c.039-.431.052-.875.052-1.319A16.356,16.356,0,0,0,160.6,71.1a19.029,19.029,0,0,1,2.463,1.123Z",
    transform: "translate(-144.019 -69.951)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_213",
    "data-name": "Trac\\xE9 213",
    d: "M80.04,117.2c-.182-.131-.378-.261-.56-.4l-.182-.144c-.2-.157-.391-.313-.586-.483-.078-.065-.143-.131-.222-.2-.209-.183-.4-.379-.6-.574a15.488,15.488,0,0,1-3.18-4.556s.13.366.143.366a6.777,6.777,0,0,1,2.411-1.214,11.957,11.957,0,0,0,2.763,3.76,13.158,13.158,0,0,0,2.867-3.969,12.66,12.66,0,0,0,.886-2.533,13.121,13.121,0,0,0-7.507,0,12.7,12.7,0,0,0-2.489,1.044h0a13.179,13.179,0,0,0-2.685,1.945,18.358,18.358,0,0,0,1.134,2.663q.2.392.43.783a18.669,18.669,0,0,0,2.216,3.081,19.682,19.682,0,0,0,1.812,1.8c.1.091.222.183.326.274a17.292,17.292,0,0,0,2.2,1.567l.808.5.821-.5a17.388,17.388,0,0,0,2.2-1.58,14.942,14.942,0,0,1-3.01-1.632Z",
    transform: "translate(-70.097 -100.904)",
    fill: "#39499b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    transform: "translate(90.651 63.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_214",
    "data-name": "Trac\\xE9 214",
    d: "M635.283,70.1H597.633a1.047,1.047,0,0,0-.756.339l-7.077,8.2,7.168,9.047a1.007,1.007,0,0,0,.782.379h37.534a1,1,0,0,0,1-.992V71.105A1.013,1.013,0,0,0,635.283,70.1ZM601.438,85.022a6.63,6.63,0,0,1-4.8-1.749l-.117-.117,1.421-2.024.169.157a4.843,4.843,0,0,0,3.428,1.423c1.134,0,1.877-.457,1.877-1.162s-1.043-.966-2.255-1.253c-1.785-.418-4.236-.992-4.236-3.59,0-2.037,1.838-3.525,4.366-3.525a6.389,6.389,0,0,1,4.379,1.527l.13.117-1.434,1.932-.156-.144a4.816,4.816,0,0,0-3.128-1.136c-.938,0-1.5.392-1.5,1.031,0,.587.808.822,2.033,1.11l.235.052a9.3,9.3,0,0,1,2.724.979,2.913,2.913,0,0,1,1.486,2.637C606.026,83.638,604.318,85.022,601.438,85.022Zm13.254-9.138h-4.77v2.285h3.988v1.958h-3.988v2.206h4.77V84.7h-7.559V73.533h7.559Zm9.031,8.8h-7.559V73.533h2.789v8.8h4.77Zm8.875-8.8h-4.77v2.285h3.988v1.958h-3.988v4.556H625.04V73.533H632.6Z",
    transform: "translate(-548.448 -70.1)",
    fill: "#39499b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(0 3.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_215",
    "data-name": "Trac\\xE9 215",
    d: "M275.445,94.7H272.5v11.567h7.78V103.76h-4.835Z",
    transform: "translate(-272.5 -94.687)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_216",
    "data-name": "Trac\\xE9 216",
    d: "M345.326,99h0a5.654,5.654,0,1,0,.56,2.454A5.791,5.791,0,0,0,345.326,99Zm-5.017,5.4h-.143a2.963,2.963,0,0,1,0-5.927h.143a2.963,2.963,0,0,1,0,5.927Z",
    transform: "translate(-326.507 -95.643)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_217",
    "data-name": "Trac\\xE9 217",
    d: "M432.9,97.563h.156a2.86,2.86,0,0,1,2.229,1.084l.052.065,2.828-.875-.078-.144a5.775,5.775,0,1,0-.026,5.444l.078-.144-2.841-.875-.052.065a2.814,2.814,0,0,1-2.19,1.031H432.9a2.826,2.826,0,1,1,0-5.653Z",
    transform: "translate(-407.039 -94.6)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_218",
    "data-name": "Trac\\xE9 218",
    d: "M524.529,100.092,529.09,94.7h-3.519l-4.991,5.653V94.7H517.7v11.58h2.88v-2.467l1.72-2.037,3.61,4.5h3.545Z",
    transform: "translate(-485.745 -94.687)",
    fill: "#181a3a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.4e5b98ea8ee7b28f51716bf6f9ad7de7.svg";
export { ForwardRef as ReactComponent };